import React from 'react';
import { Avatar, Flex, Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { ReassignPopover } from '../ReassignPopover';

interface User {
  id?: number;
  first_name: string;
  last_name: string;
  avatar_url?: string;
}

interface UserInfoSectionProps {
  user?: User;
  showReassign?: boolean;
  showAssign?: boolean;
  onReassign?: (
    userId: number,
    requisitionId?: number,
    applyToGroup?: boolean
  ) => void;
  onAssign?: (
    userId: number,
    requisitionId?: number,
    applyToGroup?: boolean
  ) => void;
  reassignTitle?: string;
  reassignDescription?: string;
  reassignFieldLabel?: string;
  assignTitle?: string;
  assignDescription?: string;
  assignFieldLabel?: string;
  isLoading?: boolean;
  isPartOfGroup?: boolean;
  groupRequisitions?: any[];
  currentRequisitionId?: number;
}

export const UserInfoSection: React.FC<UserInfoSectionProps> = ({
  user,
  showReassign = false,
  showAssign = false,
  onReassign,
  onAssign,
  reassignTitle = 'Reassign team member',
  reassignDescription = 'Assign this requisition to a different team member',
  reassignFieldLabel = 'Select team member',
  assignTitle = 'Assign team member',
  assignDescription = 'Assign a team member to this requisition',
  assignFieldLabel = 'Select team member',
  isLoading = false,
  isPartOfGroup = false,
  groupRequisitions = [],
  currentRequisitionId,
}) => {
  if (!user) {
    if (showAssign) {
      return (
        <ReassignPopover
          onReassign={onAssign}
          title={assignTitle}
          description={assignDescription}
          fieldLabel={assignFieldLabel}
          isLoading={isLoading}
          isPartOfGroup={isPartOfGroup}
          groupRequisitions={groupRequisitions}
          currentRequisitionId={currentRequisitionId}
          triggerElement={
            <Box>
              <KText color="primary-600" size="sm-medium">
                Assign
              </KText>
            </Box>
          }
          ctaLabel="Assign"
        />
      );
    }
    return (
      <KText fontSize="sm" color="secondary-500">
        -
      </KText>
    );
  }

  return (
    <>
      <Flex align="center" gap={2}>
        <Avatar
          size="xs"
          name={`${user.first_name} ${user.last_name}`}
          src={user.avatar_url}
          borderRadius="3px"
          width="18px"
          height="18px"
          className="avatar-xs"
        />
        <KText fontSize="sm" color="secondary-900">
          {user.first_name} {user.last_name}
        </KText>
        {showReassign && (
          <ReassignPopover
            onReassign={onReassign}
            title={reassignTitle}
            description={reassignDescription}
            fieldLabel={reassignFieldLabel}
            currentUser={user}
            isLoading={isLoading}
            isPartOfGroup={isPartOfGroup}
            groupRequisitions={groupRequisitions}
            currentRequisitionId={currentRequisitionId}
          />
        )}
      </Flex>
    </>
  );
};
